import { useSuspenseQuery } from '@tanstack/react-query';

import type { NavigationScreenOrgWithBaseName } from '@gitbook/app-navigation';

import { NavigationRedirect } from '../../navigation';
import { apiQuery } from '../../state';

/**
 * Redirect URLs like /@org/ to /o/:orgid/home.
 */
export function RedirectOrgWithBasename({ screen }: { screen: NavigationScreenOrgWithBaseName }) {
    const { data: subdomain } = useSuspenseQuery(
        apiQuery('getSubdomain', { subdomain: screen.organizationBaseName })
    );

    if (!subdomain) {
        return <NavigationRedirect to={{ current: { type: 'root' } }} replace />;
    }

    return (
        <NavigationRedirect
            to={{ current: { type: 'home', organization: subdomain.target.organization } }}
            replace
        />
    );
}
